// extracted by mini-css-extract-plugin
export var modal = "_ef-0";